// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination[data-v-a2640b10]{display:flex;margin:.25rem .25rem 0}.pagination button[data-v-a2640b10]{flex-grow:1;background:none;border:1px solid #ccc;padding:.5rem}.pagination button[data-v-a2640b10]:hover{cursor:pointer;background-color:#f0f0f0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
